export default __webpack_public_path__ + "static/media/card-background.fb59abf0.svg";